export default __webpack_public_path__ + "static/media/node.ec07ca2b.pdf";